import { Input, OnChanges } from '@angular/core';
import { ReportPanelColumn } from './models/reports';

export abstract class ReportSortablePanelV3Base<TRow> implements OnChanges {
  @Input() rows: TRow[] = [];
  @Input() loading: boolean = false;
  @Input() title: string = '';
  @Input() columns: ReportPanelColumn[] = [];

  labelColumnKey: string = '';
  sortedRows: TRow[] = [];
  sortKey: string = null;
  sortAsc: boolean = false;
  expanded: boolean = true;

  ngOnChanges() {
    this.applySort();
  }

  cellValue(row: TRow, column: ReportPanelColumn): string {
    const value = row[column.key as keyof TRow];
    let result = '--';
    if (value !== null && value !== undefined) {
      result = column.isPercent ? `${value}%` : String(value);
    }
    return result;
  }

  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortKey = key;
      this.sortAsc = false;
    }
    this.applySort();
  }

  private applySort() {
    let result = this.rows.slice();
    if (this.sortKey) {
      const key = this.sortKey as keyof TRow;
      const direction = this.sortAsc ? 1 : -1;
      result = result.sort((a, b) => (Number(a[key]) - Number(b[key])) * direction);
    }
    this.sortedRows = result;
  }
}
